import BroadcasterPlaylistPlayer from '@/components/BroadcastComponent/BroadcasterPlaylistPlayerComponent/BroadcasterPlaylistPlayerComponent';

export default BroadcasterPlaylistPlayer;
